export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/20e765fe22790b7f1075e229233d4cab.svg";